import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SocialAuthService } from '@abacritt/angularx-social-login';
import { AuthService } from '../services/auth-service';
import { LocalStorageService } from 'ngx-webstorage';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loggedIn: boolean = false;
  user: any;

  constructor(
    private router: Router,
    private authService: AuthService,
    public socialAuthService: SocialAuthService,
    private storage: LocalStorageService,
    private toastr: ToastrService) {
  }

  ngOnInit(): void {
    let socialUserJson = this.storage.retrieve("user")
    if (socialUserJson === null) {
      this.socialAuthService.authState.subscribe((user: any) => {
        this.user = user;
        this.loggedIn = (user != null);
        let isLoggendIn: boolean = this.authService.checkAuthState();
        if (isLoggendIn) {
          console.log(isLoggendIn + "inif");
          this.storage.store("user", this.user);
          this.storage.store("userEmailId", this.user.email);
          this.router.navigate(['/home']);
        } else {
          this.storage.clear();
          this.router.navigate(['login']);
        }
      });
    }
    else {
      this.router.navigate(['/home']);
    }
  }
}